<template>
  <div>
    <div class="row">
      <div class="col-12 px-0">
        <div class="form-group">
          <label for="name">Título da Pergunta <span class="text-danger"> *</span></label>
          <base-input
            type="text"
            id="name"
            v-model="formData.name"
            @input="emitInput"
            :error="!formData.name && ((errors && errors.name && errors.name[0] || (formData.name === '' ? 'O título da pergunta é obrigatório' : null)))"
          />
        </div>
      </div>
      <div class="col-12 px-0">
        <label for="description">Descrição</label>
        <html-editor id="description" v-model="formData.description" @input="emitInput"></html-editor>
        <small class="form-text text-danger" v-if="errors.description">{{ errors.description[0] }}</small>
      </div>
      <!-- <div class="col-12 px-0">
        <label for="description">Tipo de Pergunta *</label>
        <multiselect
          v-model="strategy"
          :options="avaliationItemStrategies || []"
          label="name"
          track-by="value"
          :allow-empty="false"
          :showNoResults="false"
          select-label=""
          deselect-label=""
          placeholder="Selecionar Período"
          :selected-label="'Selecionado'">
        </multiselect>
      </div> -->
      <div class="col-12">
        <component
          :is="strategy.component"
          :value="formData.config"
          @input="formData = Object.assign({}, formData, { config: $event })"
        />
      </div>
    </div>
  </div>
</template>

<script>
import HtmlEditor from '../../Inputs/HtmlEditor.vue';
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";

const AVALIATION_ITEM_STRATEGIES = [
  { value: "label",        name: "Título",           component: () => import("./Strategies/LabelAvaliationItemStrategy")},
  { value: "text",         name: "Texto",            component: () => import("./Strategies/TextAvaliationItemStrategy")},
  { value: "number",       name: "Número",           component: () => import("./Strategies/NumberAvaliationItemStrategy")},
  { value: "boolean",      name: "Sim / Não",        component: () => import("./Strategies/BooleanAvaliationItemStrategy")},
  { value: "date",         name: "Data",             component: () => import("./Strategies/DateAvaliationItemStrategy")},
  { value: "select",       name: "Multipla Escolha", component: () => import("./Strategies/SelectAvaliationItemStrategy")},
  { value: "likert_scale", name: "Escala de Likert", component: () => import("./Strategies/LikertScaleAvaliationItemStrategy")},
];

export default {
  name: "AvaliationItemForm",
  components: {
    HtmlEditor,
    Multiselect,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    emitInput() {
      this.$emit("input", this.formData);
    },
  },
  computed: {
    avaliationItemStrategies: () => AVALIATION_ITEM_STRATEGIES,
    formData: {
      get() {
        return { ...this.value, strategy: 'number' };
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    strategy: {
      get() {
        return AVALIATION_ITEM_STRATEGIES.find(strategy => strategy.value === this.formData.strategy) || AVALIATION_ITEM_STRATEGIES[0];
      },
      // get() {
      //   return this.avaliationItemStrategies.find(strategy => strategy.value === this.formData.strategy) || this.avaliationItemStrategies[0];
      // },
      // set(value) {
      //   console.log("[AvaliationItemForm][strategy] Setting strategy to ", value.value)
      //   this.formData = Object.assign({}, this.formData, { strategy: value.value })
      // },
    },
  },
}
</script>
